import { FormControl, Grid, InputLabel, MenuItem, MuiThemeProvider, Select } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { WithStyles } from 'decorators/withStyles';
import { IButtons } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';

import ColorPicker from './ColorPicker';

interface IProps {
  classes?: any;
}

interface IState {
  model: IButtons;
}

@WithStyles(() => ({
  buttonText: {
    marginTop: 16,
    width: '100%'
  }
}))
export default class ActionButton extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { model: null };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(
        rxjsOperators.logError(),
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(model => model.buttons)
      )
      .subscribe(model => {
        this.setState({ model });
      });
  }

  onChangeButtonText = (event: any) => {
    themeCustomizerService.setData({
      buttons: { ...this.state.model, text: event.target.value }
    });
  };

  onChangePrincipalColor = (color: string) => {
    themeCustomizerService.setData({
      buttons: { ...this.state.model, bgcolor: color }
    });
  };

  onChangeMousoverColor = (color: string) => {
    themeCustomizerService.setData({
      buttons: { ...this.state.model, bgcolorhover: color }
    });
  };

  onChangeFontColor = (color: string) => {
    themeCustomizerService.setData({
      buttons: { ...this.state.model, font: { color } }
    });
  };

  render() {
    const { classes } = this.props;
    const { model } = this.state;

    if (!model) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <ColorPicker value={model.bgcolor} label="Cor Principal" handleChangeColor={this.onChangePrincipalColor} />
        <ColorPicker
          label="Cor ao passar o Mouse"
          value={model.bgcolorhover}
          handleChangeColor={this.onChangeMousoverColor}
        />
        <ColorPicker label="Cor da Letra" value={model.font.color} handleChangeColor={this.onChangeFontColor} />
        <Grid item xs={12}>
          <FormControl className={classes.buttonText}>
            <InputLabel htmlFor="button-text">Texto do Botão</InputLabel>
            <Select
              value={model.text || 'Finalizar Pagamento'}
              onChange={this.onChangeButtonText}
              name="buttonText"
              displayEmpty
              autoWidth={false}
              disableUnderline={true}
              inputProps={{
                name: 'buttonText',
                id: 'button-text'
              }}
            >
              <MenuItem value="" disabled>
                Selecione...
              </MenuItem>
              <MenuItem value="Finalizar Pagamento">Finalizar Pagamento/ Finalizar Assinatura</MenuItem>
              <MenuItem value="Pagar e Receber Agora">Pagar e Receber Agora/ Pagar e Assinar Agora</MenuItem>
              <MenuItem value="Concluir Compra">Concluir Compra/ Concluir Assinatura</MenuItem>
              <MenuItem value="Pagar Agora">Pagar Agora/ Pagar e Assinar</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </MuiThemeProvider>
    );
  }
}
